<div class="tw-relative tw-flex tw-flex-col tw-gap-4 tw-rounded-t-6 tw-bg-white tw-px-6 tw-pb-6 tw-pt-9">
  <div class="tw-absolute tw-left-1/2 tw-top-2 tw-h-1 tw-w-20 -tw-translate-x-1/2 tw-rounded-full tw-bg-gray-400 tw-opacity-20"></div>
  @if (isDetected()) {
    <div class="tw-flex tw-flex-col">
      <p class="tw-font-lexend tw-text-400 tw-font-bold tw-text-gray-800" i18n="@@confirmYourLocation">Confirm your location</p>
      <p class="tw-font-body tw-text-200 tw-text-gray-400" i18n="@@detectedFromYourLocation">We've detected these details from your location</p>
    </div>
    <div class="tw-flex tw-flex-col tw-gap-4 tw-rounded-3 tw-border tw-border-solid tw-border-gray-200 tw-bg-white tw-p-4 tw-shadow-z4">
      @if (location()?.area) {
        <div id="detectedArea" class="tw-flex tw-flex-col">
          <div class="tw-flex tw-items-center tw-gap-1">
            <span class="tw-font-lexend tw-text-100 tw-uppercase tw-text-gray-500" i18n="@@autofillAreaLabel">Area</span>
            <cs-icon class="tw-h-4 tw-w-4" [iconName]="'autofill_check'"></cs-icon>
          </div>
          <span class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{ location()?.area }}</span>
        </div>
      }
      @if (location()?.pincode) {
        <div id="detectedPincode" class="tw-flex tw-flex-col">
          <div class="tw-flex tw-items-center tw-gap-1">
            <span class="tw-font-lexend tw-text-100 tw-uppercase tw-text-gray-500" i18n="@@autofillPincodeLabel">Pincode</span>
            <cs-icon class="tw-h-4 tw-w-4" [iconName]="'autofill_check'"></cs-icon>
          </div>
          <span class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{ location()?.pincode }}</span>
        </div>
      }
      @if (cityLine()) {
        <div id="detectedCity" class="tw-flex tw-flex-col">
          <div class="tw-flex tw-items-center tw-gap-1">
            <span class="tw-font-lexend tw-text-100 tw-uppercase tw-text-gray-500" i18n="@@autofillCityLabel">City</span>
            <cs-icon class="tw-h-4 tw-w-4" [iconName]="'autofill_check'"></cs-icon>
          </div>
          <span class="tw-font-lexend tw-text-300 tw-font-medium tw-text-gray-800">{{ cityLine() }}</span>
        </div>
      }
      <div id="editDetectedLocation" role="button" class="tw-flex tw-h-8 tw-items-center tw-gap-1 tw-self-start tw-font-lexend tw-text-300 tw-font-semibold tw-text-teal-600" (click)="edit()">
        <span i18n="@@autofillEdit">Edit</span>
        <cs-icon class="tw-h-4 tw-w-4" [iconName]="'autofill_chevron'"></cs-icon>
      </div>
    </div>
    @if (autofill.delivery(); as delivery) {
      <app-delivery-estimate-strip class="tw-block tw-overflow-hidden tw-rounded-2"
        [dayDifference]="delivery.dayDifference"
        [expectedDeliveryDate]="delivery.expectedDeliveryDate"></app-delivery-estimate-strip>
    }
    <button csButton id="confirmLocationCta" type="button" class="tw-w-full" (click)="confirm()">
      <span i18n="@@confirmLocation">Confirm Location</span>
    </button>
  } @else {
    <div class="tw-flex tw-items-center tw-gap-2">
      <cs-icon class="tw-h-6 tw-w-6 tw-shrink-0" [iconName]="'my_location'"></cs-icon>
      <div class="tw-flex tw-flex-col tw-gap-1">
        <p class="tw-font-lexend tw-text-400 tw-font-bold tw-text-gray-800" i18n="@@detectingYourLocation">Detecting your location...</p>
        <div class="tw-h-2 tw-w-40 tw-animate-pulse tw-rounded-2 tw-bg-gray-200"></div>
      </div>
    </div>
  }
</div>
